export default "__VITE_ASSET__vqE3k0Y3__"